var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.startTime && _vm.currentTime)?_c('div',{staticClass:"timeCode",class:_vm.expanded ? 'expanded' : '',on:{"click":_vm.toggleExpand}},[_vm._v(" "+_vm._s(_vm.timestamp)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }